module.exports = __webpack_public_path__ + "img/Inverter.fa26ef26.png";